import { render, staticRenderFns } from "./SendOnboardingLink.vue?vue&type=template&id=273bd65a&scoped=true"
import script from "./SendOnboardingLink.vue?vue&type=script&lang=js"
export * from "./SendOnboardingLink.vue?vue&type=script&lang=js"
import style0 from "./SendOnboardingLink.vue?vue&type=style&index=0&id=273bd65a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273bd65a",
  null
  
)

export default component.exports